import { getToken, setToken, removeToken } from '@/store/local/auth'
import { test_uesrinfo } from '@/api/user'
import { Message, MessageBox } from 'element-ui'
import router from '@/router'
import Vue from 'vue'
import LoginTimeoutDialog from '@/components/LoginTimeoutDialog/index.vue'

class AuthService {
  constructor() {
    // 防重复显示登录过期对话框的标志位
    this.isShowingDialog = false
  }

  async checkLoginStatus() {
    try {
      if (!getToken()) {
        this.handleLoginExpired('您的登录已过期，请重新登录')
        return false
      }

      const response = await test_uesrinfo()
      if (response.data.code !== 1) {
        this.handleLoginExpired('您的登录状态已失效，请重新登录')
        return false
      }

      return true
    } catch (error) {
      console.error('登录状态检查失败:', error)
      this.handleLoginExpired('无法验证您的登录状态，请重新登录')
      return false
    }
  }

  handleLoginExpired(message) {
    removeToken()
    localStorage.removeItem('userInfo')
    this.showLoginExpiredDialog(message)
  }


  showLoginExpiredDialog(message) {
    const LoginTimeoutDialogClass = Vue.extend(LoginTimeoutDialog)
    const instance = new LoginTimeoutDialogClass({
      propsData: {
        visible: true,
        message: message
      }
    })
    
    instance.$mount()
    document.body.appendChild(instance.$el)

    instance.$on('confirm', () => {
      instance.$destroy()
      document.body.removeChild(instance.$el)
      this.redirectToLogin()
    })
  }

  redirectToLogin() {
    const currentPath = router.currentRoute.fullPath
    if (!currentPath.startsWith('/store/entry')) {
      router.push(`/store/entry?redirect=${encodeURIComponent(currentPath)}`)
    }
  }

}

const authService = new AuthService()
export default authService
